import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import { ButtonLoader } from "Components";
import { authService } from "Service/Axios";
import { useFolderList } from "Constant/apiHooks";
import {
  FORM_BUILDER_FORM_EDIT_URL,
  FORM_BUILDER_FORM_MULTIPLE_EDIT_URL,
} from "Constant/api";
import { Validator } from "Utils/validator";

export const MoveForm = ({
  show,
  type,
  selectedForm,
  selectedFormIds,
  toggle,
  fetchFolderList,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    folderId: "",
  });
  const [errMsg, setErrMsg] = useState({
    folderId: "",
  });

  const { folderId } = formData;

  const { folderList, loading: folderLoading } = useFolderList();

  // On Change
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    if (e.target.name === "folderId") {
      if (!Validator.text(e.target.value)) {
        setErrMsg((prev) => ({
          ...prev,
          folderId: t("common.messages.error.common.folderId.blank"),
        }));
      } else {
        setErrMsg((prev) => ({
          ...prev,
          folderId: "",
        }));
      }
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (Validator.text(folderId)) {
        resolve(true);
      } else {
        if (!Validator.text(folderId)) {
          setErrMsg((prev) => ({
            ...prev,
            folderId: t("common.messages.error.common.folderId.blank"),
          }));
        }
        resolve(false);
      }
    });
  };

  // On Submit
  const onSaveForm = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        setLoading(true);
        if (type === "single") {
          if (selectedForm && selectedForm?.formId) {
            const payload = {
              ...selectedForm,
              folderId,
            };
            await authService(FORM_BUILDER_FORM_EDIT_URL, "POST", payload);
            toast.success(t("common.messages.notification.success.moveForm"));
          }
        } else {
          if (selectedFormIds.length > 0) {
            const payload = {
              ids: selectedFormIds,
              type: "Move",
              targetFolderId: folderId,
            };
            await authService(
              FORM_BUILDER_FORM_MULTIPLE_EDIT_URL,
              "POST",
              payload
            );
            toast.success(
              t("common.messages.notification.success.bulkMoveForm", {
                count: selectedFormIds.length,
              })
            );
          }
        }
        toggle();
        fetchFolderList();
      } catch (error) {
        setLoading(false);
        if (error.response && error.response.data) {
          toast.error(error.response.data.message);
        }
      }
    }
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="justify-content-center">
        <Modal.Title>{t("auth.formBuilder.moveForm")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="mb-3">
          <label htmlFor="folderId">{t("common.label.folder")}</label>
          <select
            className="form-select"
            id="folderId"
            aria-label="Floating label select example"
            name="folderId"
            value={folderId}
            onChange={handleChange}
          >
            <option value="">Select</option>
            {!folderLoading &&
              folderList &&
              folderList.length > 0 &&
              folderList
                .filter((folder) => folder.gid !== selectedForm.folderId)
                .map((folder) => (
                  <option value={folder.gid}>{folder.name}</option>
                ))}
          </select>
          {errMsg.folderId && <p className="error">{errMsg.folderId}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="outline-primary" onClick={toggle} className="">
          {t("common.button.cancel")}
        </Button>
        {!loading ? (
          <Button variant="primary" onClick={onSaveForm}>
            {t("common.button.move")}
          </Button>
        ) : (
          <ButtonLoader />
        )}
      </Modal.Footer>
    </Modal>
  );
};
